import React from "react";

import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import styles from "./styles.scss";

// Read-only: the spent time comes from the timesheets and cannot be edited here.
function SpentHours({ spentHours }: Props) {
  return (
    <div className={styles.spentHours}>
      <p className={styles.text}>
        {Math.round(spentHours * 100) / 100}
        <AllocationUnit />
      </p>
    </div>
  );
}

export { SpentHours };
